<template>
    <div class="nwf">
        <div class="ff">
            <p style="font-weight: 700; color: #196F3D; padding-left: 1rem;">404! Page Not Found</p> 
        </div>
    </div>
</template>

<script>
    export default {
        name: "error404"
    }
</script>

<style scoped>
.nwf {
	height: 100vh;
    width: 800px;
}

p {
    font-size: 5rem;
    margin: 0;
    position: relative;
    top: 50%;
    left: 40%;
}
</style>